




























































































import HeaderLayout from '@/layouts/nested/HeaderLayout.vue';
import {Component} from 'vue-property-decorator';
import Base from '../../Base';
import WHeaderBtn from '@/components/WHeaderBtn.vue';
import { DCPConference } from '@/models/DCPConference';
import DCPModeratorService from '@/service/DCPModeratorService';

@Component({
	components: { HeaderLayout, WHeaderBtn }
})
export default class ModeratorDCP extends Base {

  title = 'Neues DCP';
  moderatorPIN = "999999";
  participantPIN = "111111";

  dcpWindow: Window | null = null;
  dcpUrl: string | undefined = process.env.VUE_APP_DCP_URL;

  currentConference: DCPConference | null = null;

  mounted(): void {
    this.getConferences();
  }

  private getConferences() {
    console.log("mounted: get conferences");
    DCPModeratorService.getDCPConferences().then((obj) => {
      console.log("mounted: get conferences result ->", obj);
      if (obj.length > 0) {
        this.currentConference = obj[0];
      } else {
        this.currentConference = null;
      }
    });
  }

	submit(): void {
    console.log('submit', this.title, this.moderatorPIN, this.participantPIN);
    DCPModeratorService.startDCPConference({
      title: this.title,
      moderatorPIN: this.moderatorPIN,
      participantPIN: this.participantPIN,
    }).then((obj) => {
      if (obj) {
        this.currentConference = obj;
      }
    }).catch(this.showNetworkError);
	}

  stopDCP(): void {
    if (!this.currentConference) return;
    DCPModeratorService.stopDCPConference(this.currentConference.id).then(() => this.currentConference = null);
  }

  openDCP(): void {
    if (!this.currentConference) return;
    // const language = this.$i18n.locale;
    if (this.dcpUrl === undefined) {
      console.log('DCP_URL is not set');
      return
    }
    this.dcpWindow = window.open(`${this.dcpUrl}/${this.currentConference.moderatorPIN}?moderator=true`, '_blank');
    const interval = setInterval(() => {

      // if (this.dcpWindow && this.dcpWindow.location.origin === new URL(this.dcpUrl).origin)
      // console.log('this.dcpWindow.location.origin', this.dcpWindow?.location.origin);
      // console.log('new URL(this.dcpUrl).origin', new URL(this.dcpUrl || "").origin);


      if (this.dcpWindow && this.dcpUrl) {
        console.log('post connecting', this.dcpUrl);
        this.dcpWindow.postMessage('connecting', this.dcpUrl);
        // this.dcpWindow.postMessage('connecting', "http://localhost:5173/");
      }
    }, 1000);

    window.addEventListener('message', (event) => {
      console.log('event received', event.data);

      if (event.origin !== this.dcpUrl) return;
      if (event.data === 'connected') {
        console.log('Conference connected');
        clearInterval(interval);

        console.log('post token');
        if (this.dcpWindow) {
          this.dcpWindow.postMessage('authentication=' + JSON.stringify(this.$store.getters.authentication), this.dcpUrl);
          this.$store.commit('setLastActionTimestamp');
        }
      }
      if (event.data === 'disconnected') {
        console.log('Conference disconnected');
      }
    });
  }

  openParticipant(): void {
    if (!this.currentConference) return;
    // const language = this.$i18n.locale;
    if (this.dcpUrl === undefined) {
      console.log('DCP_URL is not set');
      return
    }
    this.dcpWindow = window.open(`${this.dcpUrl}/${this.currentConference.participantPIN}?username=MaxMustermann`, '_blank');
  }

  openCoModerator(): void {
    if (!this.currentConference) return;
    // const language = this.$i18n.locale;
    if (this.dcpUrl === undefined) {
      console.log('DCP_URL is not set');
      return
    }
    this.dcpWindow = window.open(`${this.dcpUrl}/${this.currentConference.moderatorPIN}?username=MaxMustermann`, '_blank');
  }

}
